/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Error_TitleInputs */



/**
* | output |
* | --- |
* | "Service Unavailable" |
*
* @param {Offline_Error_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_error_title = /** @type {((inputs?: Offline_Error_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Error_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Service Indisponible")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dienst nicht verfügbar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Servizio non disponibile")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сервис недоступен")
	if (locale === "es") return /** @type {LocalizedString} */ ("Servicio No Disponible")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("暂停服务")
	if (locale === "ja") return /** @type {LocalizedString} */ ("サービスは利用できません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सेवा अनुपलब्ध है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Serviço não disponível")
	return /** @type {LocalizedString} */ ("Service Unavailable")
});